@if (customerLogo; as logo) {
<img class="brand-img w-auto d-block flex-shrink-0" [class.is-tile]="logo.tile" [ngClass]="'is-' + size"
  [src]="(light && logo.white) || logo.color" [alt]="logo.alt" />
} @else {
<span class="brand d-inline-flex align-items-center lh-1 text-nowrap" [class.is-light]="light" [ngClass]="'is-' + size" role="img" aria-label="Wise">
  <img class="brand__mark w-auto d-block" src="./assets/media/logos/wise-mark.png" alt="" />
  <span class="brand__word fw-normal">Wise</span>
</span>
}
